import { motion } from "framer-motion";
import type { ReactNode } from "react";

const AnimatedIcon = ({ children }: { children: ReactNode }) => (
  <motion.span
    initial={{ scale: 1, rotate: 0, opacity: 0.85 }}
    animate={{ scale: [1, 1.08, 1], rotate: [0, 4, 0], opacity: [0.85, 1, 0.85] }}
    transition={{ duration: 1.6, ease: "easeInOut", repeat: Infinity, repeatType: "reverse" }}
    style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}
  >
    {children}
  </motion.span>
);

export default AnimatedIcon;

